import { getCurrentOrgId } from 'common-src/features/auth/selectors';
import { SUPER_ADMIN_ORG_ID } from 'common-src/models/Organization/constants';
import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getIsSuperAdminOrg = (state) => getCurrentOrgId(state) === SUPER_ADMIN_ORG_ID;

export const getIsMultiOrg = (state) => allModelsSelector(state, 'Organization').length > 1;
